import { SelectedDataType } from '~/_shared/components/customizeMetrics/selectedDataMetric.type';
import type { DemographicsRegion } from '~/store/demographics/demographics.repository';
import { DemographicsDataProviders } from '~/store/demographics/demographics.types';
import type { DataLayerGroupData } from '~/store/mapSettings/data/dataLayers/mapSettingsDataLayers.state';
import type { DemographicMetricModel } from '../demographicsMetric.factory';

export const getDataLayersMetrics = (
  layer: DataLayerGroupData | undefined,
  agsData: ReadonlyArray<DemographicsRegion>,
  accessible: ReadonlySet<string>,
): ReadonlyArray<DemographicMetricModel> => {
  const dataLayerDemographics = agsData.find(region => region.id === layer?.region)?.demographics ?? [];

  return layer
    ? dataLayerDemographics
      .filter(({ id }) => layer.demographics.includes(id) && accessible.has(id))
      .map(demographic => ({
        type: SelectedDataType.Demographic,
        demographic,
        provider: DemographicsDataProviders.AGS,
        inferenceSource: {
          type: 'DataLayers',
          region: layer.region,
          layerName: layer.title,
        },
      }))
    : [];
};
